import { Component, OnInit } from '@angular/core';
import { AppServiceService } from '../app-service.service';
import { UserDetailsMainModel } from '../user-details-model';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';



@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {
  isProdConfig:boolean = false;
  isUnitConfig:boolean= false;
  isProfile:boolean = true;
  isAlert:boolean = false;
  isName:boolean = false;
  isHelp:boolean=true;
  hasAuthenticated = false;
  previousUrl: string;

  constructor(private appService:AppServiceService,
    private router:Router) { }

  ngOnInit(): void {
   
  }

 
 
}
